import React from 'react';
import { ButtonProps } from '@chakra-ui/react';
import { Button as ButtonChakra } from '@/components/Button/Button';

export default function Index(props: ButtonProps) {
  return <ButtonChakra {...props} />;
}
